import { mapGetters } from "vuex";
import * as salesReportService from "../../Service/Report.service";
import * as constants from "../../Constants/ReportTypesConstants";
import firestore from "../../config/firebase";
import SummerNote from "../../components/SummerNoteEditor/SummerNote";

import { toasterModel, toasterColor } from "../../Models/ToasterModel";

export default {
  name: "dashboard",
  components: {
    SummerNote,
  },
  mounted() {},
  data() {
    return {
      documentId: "Prod",
      announcements: "",
      readonlyMode: true,
    };
  },

  computed: {
    ...mapGetters(["getUserDetails"]),
  },
  mounted() {
    this.onChangeAnnouncement();
    this.InitDocument();
  },

  methods: {
    getHeight(readonlyMode) {
      var height = readonlyMode ? screen.height - 300 : screen.height - 350;
      debugger;
      return screen.height;
    },
    onChangeAnnouncement() {
      let context = this;
      firestore
        .collection(constants.FirebaseCollectionName.Announcements)
        .doc(context.documentId)
        .onSnapshot(function(doc) {
          debugger;
          if (context.documentId == doc.id && doc.exists == true) {
            context.announcements = doc.data().data;
          }
        });
    },
    async InitDocument() {
      this.$store.commit("toggleLoading", true);
      let context = this;

      var document = await salesReportService.getReportStatusInfoById(
        this.documentId,
        constants.FirebaseCollectionName.Announcements
      );

      debugger;
      ///Create a new Report
      if (document.exists == false) {
        this.announcements = await salesReportService.createorUpdateDocument(
          this.documentId,
          constants.FirebaseCollectionName.Announcements,
          ""
        );
      } else {
        //if document already exist,check whether there is a record with the specified date filter
        this.announcements = document.data().data;
      }

      this.$store.commit("toggleLoading", false);
    },
    async cancelEdit() {
      this.readonlyMode = true;
      await this.InitDocument();
    },
    async saveAnnouncement() {
      this.$store.commit("toggleLoading", true);
      this.readonlyMode = true;

      debugger;
      var summerNoteElement = document.getElementById("Announcement");
      var summerNoteContent = $(summerNoteElement).summernote("code");

      summerNoteContent = await this.processSummerNoteContent(
        summerNoteContent
      );

      if (summerNoteContent.trim().length == 0) {
        this.$store.commit(
          "toaster",
          toasterModel("Comment is empty", toasterColor.info)
        );

        this.$store.commit("toggleLoading", false);
        return false;
      }

      this.announcements = await salesReportService.createorUpdateDocument(
        this.documentId,
        constants.FirebaseCollectionName.Announcements,
        summerNoteContent
      );
      this.$store.commit("toaster", toasterModel("Successfully Updated"));

      this.$store.commit("toggleLoading", false);
    },
    async processSummerNoteContent(summerNoteContent) {
      debugger;
      var html = $.parseHTML(summerNoteContent);

      var imageTags = $(html).find("img");
      let i = 0;
      for (i = 0; i < imageTags.length; i++) {
        var image = imageTags[i];

        if (image.src.includes("firebase") == false) {
          let fetchBlobFromDataUrl = await fetch(image.src);

          if (fetchBlobFromDataUrl.ok) {
            var blob = await fetchBlobFromDataUrl.blob();

            var upload = await salesReportService.UploadImage(blob, Date.now());
            if (upload.state == "success") {
              var imageUrl = await upload.ref.getDownloadURL();
              image.src = imageUrl;
            }
          }
        }
      }
      var div = $("<div</div>");
      div.append(html);

      return div[0].innerHTML;
    },
  },
};
